module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_02.0d83fa17.png";